module.exports = __webpack_public_path__ + "img/01.4f0b074d.svg";